import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../../../../services/api.service";
import {Location} from "@angular/common";
import {Ad} from "../../../../interfaces/ad";
import { DefaultFrameComponent } from '../../../../frames/default-frame/default-frame.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'kaz-success-ad',
    templateUrl: './success-ad.component.html',
    styleUrls: ['./success-ad.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DefaultFrameComponent, FaIconComponent]
})
export class SuccessAdComponent implements OnInit{
  private _route = inject(ActivatedRoute);
  private _router = inject(Router);
  private _api = inject(ApiService);

  ad: Ad | null = null;
  ngOnInit() {
    this._route.params.subscribe(params => {
      const adId = params['id']!;
      this.getAd(adId).then();
      setTimeout(() => {
        this._router.navigate(['ad/' + adId]).then();
      }, 4000);
    });
  }

  async getAd(id: string) {
    try {
      if (id !== '') {
        this.ad = await this._api.getAd(id);
      }
    } catch (err) {

    }
  }
}
